<app-company-fit>
  <app-action-buttons (resetAll)="resetAll()" (saveToSpaces)="openSaveToSpaces()"></app-action-buttons>
</app-company-fit>
